import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ApplicationsRoutingModule } from './applications-routing.module';
import { ApplicationsComponent } from './applications.component';

import { DxTextBoxModule,DxSelectBoxModule, DxTagBoxModule, DxTreeViewModule, DxDropDownBoxModule, DxBoxModule, DxButtonModule, DxResponsiveBoxModule, DxListModule, DxTileViewModule, DxAutocompleteModule, DxMenuModule, DxTemplateModule, DxGalleryModule, DxScrollViewModule, DxPopupModule } from "devextreme-angular";
import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';


@NgModule({
  declarations: [
    ApplicationsComponent
  ],
  imports: [
    CommonModule,
    ApplicationsRoutingModule,
    MdbGlobalModule,
    DxScrollViewModule,
    DxAutocompleteModule,
    DxMenuModule,
    DxTemplateModule,
    DxGalleryModule,
    DxTileViewModule,
    DxListModule,
    DxResponsiveBoxModule,
    DxButtonModule,
    DxBoxModule,
    DxTileViewModule,
    DxPopupModule,
    DxDropDownBoxModule, 
    DxTreeViewModule,
    DxTagBoxModule,
    DxSelectBoxModule,
    DxTextBoxModule

  ], 
  exports:[ApplicationsComponent]
})
export class ApplicationsModule { }
